import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSearchParams } from 'react-router-dom';
import { ChevronLeft, ListChecks } from 'lucide-react';
import API_ENDPOINTS from '../../config/api';
import { useTranslation } from '../../hooks/useTranslation';
import TaskCard from './TaskCard';
import SelfAssessmentTask from './SelfAssessmentTask';

/**
 * HomeworkList — the Kotitehtävät tab (#693): what a participant does once
 * the workshop is over. First the self-assessment's post wave, the same
 * statements as before plus one. The change meter and the feedback
 * (specs/me-change-meter.md) join this list when they are built.
 */
const Intro = styled.p`margin: 0 0 0.4rem; color: #9aa4b2; line-height: 1.55;`;
const Back = styled.button`all: unset; cursor: pointer; display: inline-flex; align-items: center; gap: 0.3rem; color: #9aa4b2; font-size: 0.9rem; margin-bottom: 0.8rem; &:hover { color: #fff; }`;
const List = styled.div`display: flex; flex-direction: column; gap: 0.7rem;`;

export default function HomeworkList({ instanceId, onTodoChange = null }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const open = searchParams.get('tehtava') === 'itsearviointi';
  const [itse, setItse] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${API_ENDPOINTS.ME_SELF_ASSESSMENT()}?instanceId=${encodeURIComponent(instanceId)}&wave=post`, { credentials: 'include', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled && d) setItse(d); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [instanceId, open]);
  useEffect(() => { if (onTodoChange && itse !== null) onTodoChange(!itse.submitted); }, [itse, onTodoChange]);

  if (open) {
    return (
      <>
        <Back onClick={() => setSearchParams({})}><ChevronLeft size={16} /> {t('me.preWorkBack')}</Back>
        <SelfAssessmentTask instanceId={instanceId} wave="post" onChange={(d) => setItse(d)} />
      </>
    );
  }
  return (
    <List>
      <Intro>{t('me.homeworkIntro')}</Intro>
      <TaskCard icon={ListChecks} title={t('me.selfAssessment.postLabel')}
        hint={itse?.submitted ? t('me.selfAssessment.done') : t('me.selfAssessment.postHint')}
        state={itse?.submitted ? 'done' : 'open'} doneLabel={t('me.preWorkDone')}
        onClick={() => setSearchParams({ tehtava: 'itsearviointi' })} />
    </List>
  );
}
